define.alias("shared/components/shared/restricted-area/body", "settings/components/shared/restricted-area/body");